module.exports = __webpack_public_path__ + "img/content_page.5be18784.png";